import { tap } from 'rxjs';
import { Handler } from '../../../Shared/Application/UseCases/Handler';
export class LoginHandler extends Handler {
  constructor(customerRepository, setCredentials) {
    super();
    this.customerRepository = customerRepository;
    this.setCredentials = setCredentials;
  }
  handle(params) {
    return this.customerRepository.findByCustomer(params.username, params.password, params.grantType).pipe(tap(this.setCredentials));
  }
}
